export default __webpack_public_path__ + "asterisk.png";